module.exports = __webpack_public_path__ + "static/img/Refer_A_Friend_center.d2f8677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Refer_A_Friend_center.png
// module id = 941
// module chunks = 32